import { LocalStorage } from "../../shared/util/LocalStorage";
export const storage = new LocalStorage("manual");
